import { createFileRoute } from "@tanstack/react-router";
import { SeoPage } from "@/components/SeoPage";
import { faqJsonLd } from "@/lib/seo-jsonld";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { SOURCE_FOHM_VAGLEDNING, SOURCE_ALKOHOLLAGEN, LAST_REVIEWED } from "@/lib/official-sources";

const faqs = [
  { q: "När behövs tillfälligt serveringstillstånd?", a: "För enstaka tillfällen eller en kortare avgränsad period, t.ex. festivaler, marknader, bröllop eller företagsevent." },
  { q: "Vad är skillnaden mot stadigvarande?", a: "Tillfälligt tillstånd gäller för ett enstaka tillfälle eller en kortare period. Stadigvarande tillstånd gäller tills vidare och har strängare krav på lokal och verksamhet." },
  { q: "Krävs kunskapsprov?", a: "Ofta ja, även för tillfälligt tillstånd, men kraven kan vara lägre vid mindre slutna sällskap. Kontrollera med kommunen." },
];

export const Route = createFileRoute("/tillfalligt-serveringstillstand")({
  component: () => (
    <SeoPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Guider", to: "/serveringstillstand-och-kunskapsprov" },
        { label: "Tillfälligt tillstånd" },
      ]}
      title="Tillfälligt serveringstillstånd"
      intro="Allt om tillfälligt serveringstillstånd för enstaka evenemang, festivaler, bröllop och företagsevent – krav, ansökan och tidplan."
      lastReviewed={LAST_REVIEWED}
      sources={[SOURCE_FOHM_VAGLEDNING, SOURCE_ALKOHOLLAGEN]}
      sections={[
        { h2: "Till allmänheten eller slutet sällskap", body: "Tillfälligt tillstånd ges antingen till allmänheten (festival, marknad) eller till slutet sällskap (bröllop, konferens). Kraven skiljer sig åt – tillstånd till allmänheten är striktare." },
        { h2: "Ansökan", body: "Ansök hos kommunen där evenemanget ska hållas. Lämna in i god tid – minst 6–8 veckor innan. Bifoga ritning, meny, ordningsplan och uppgifter om ansvariga." },
        { h2: "Krav vid evenemang", body: "Avgränsad serveringsyta, ordningsvakter vid behov, åldersgräns 18 år och plan för ordning och nykterhet. Matservering är sedan 1 juni 2026 inte längre något krav – lokal- och säkerhetskraven gäller däremot precis som tidigare." },
        { h2: "Kunskapsprov", body: "För större eller återkommande evenemang krävs godkänt kunskapsprov. Träna obegränsat i Alkoholprovet och gör provsimulering inför skarpt prov." },
      ]}
      faqs={faqs}
      related={{
        title: "Relaterade sidor",
        links: [
          { to: "/serveringstillstand-och-kunskapsprov", label: "Hub – alla guider" },
          { to: "/serveringstillstand-food-truck", label: "För food truck" },
          { to: "/serveringstillstand-catering", label: "För catering" },
          { to: "/serveringstillstand-bar", label: "För bar & nattklubb" },
          { to: "/serveringstillstand-stockholm", label: "Serveringstillstånd Stockholm" },
          { to: "/serveringstillstand-goteborg", label: "Serveringstillstånd Göteborg" },
          { to: "/serveringstillstand-malmo", label: "Serveringstillstånd Malmö" },
          { to: "/kunskapsprov-alkohollagen", label: "Kunskapsprov i alkohollagen" },
        ],
      }}
    />
  ),
  head: () => ({
    meta: [
      { title: "Tillfälligt serveringstillstånd – evenemang & event" },
      { name: "description", content: "Tillfälligt serveringstillstånd för festival, bröllop, marknad och event: krav, ansökan, handläggningstid och kunskapsprov." },
      { property: "og:title", content: "Tillfälligt serveringstillstånd" },
      { property: "og:description", content: "Krav och ansökan för tillfälligt tillstånd." },
      { property: "og:url", content: "https://alkoholprovet.se/tillfalligt-serveringstillstand" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/tillfalligt-serveringstillstand" }],
    scripts: [
      faqJsonLd(faqs),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Guider", url: "https://alkoholprovet.se/serveringstillstand-och-kunskapsprov" },
        { label: "Tillfälligt tillstånd", url: "https://alkoholprovet.se/tillfalligt-serveringstillstand" },
      ]),
    ],
  }),
});
